import React from "react";
import Base from "../../common/components/Base";
import Items from "./Items";
import Loading from "../components/loading";
import Operations from "../components/operations";
import branch from "../../common/containers/branch";
import * as cartActions from "../../common/actions/creators/cartAction";

export class Panel extends Base {
	constructor(props, context) {
		super(props, context);
		this.handlerUpdateMiniCart = this.handlerUpdateMiniCart.bind(this);
	}

	componentDidMount() {
		document.addEventListener("update-cart", this.handlerUpdateMiniCart);
	}

	componentWillUnmount() {
		document.removeEventListener("update-cart");
	}

	handlerUpdateMiniCart() {
		this.props.dispatch(cartActions.fetchCart(this.props.readOnly));
	}

	componentDidUpdate() {
		const { amount } = this.props.cartReducer.cart;

		if (amount > 0) {
			$("#cartCount").attr("data-notifications", amount);
		} else {
			$("#cartCount").removeAttr("data-notifications");
		}
	}

	renderLoad() {
		return <Loading />;
	}

	renderAfterLoad() {
		return (
			<React.Fragment>
				<h6>Carrinho de compras</h6>
				<Items readOnly={this.props.readOnly} />
				<Operations />
			</React.Fragment>
		);
	}

	render() {
		return (
			<React.Fragment>
				{this.renderContent(this.props.cartReducer.loading)}
			</React.Fragment>
		);
	}
}

export default branch(Panel);
